import React from 'react'
import HeaderSection from './header/header'
import PhotoGallery from './PhotoGallery'
import PropertyDetails from './PropertyDetails/detail'
import PropertyInfo from './PropertyDetails/PropertyInfo'
import ContactSection from './PropertyDetails/ContactSection'
import MoreDetailsSection from './moreDetails/MoreDetails'
import AboutProject from './AboutProject/AboutProject'
import AmenitiesSection from './Amenities/Amenities'
import OtherPropertiesSection from './OtherProperties/OtherProperties'

const LeftSection = ({propertyData}) => {

  console.log("propertyData",propertyData);
  


  return (
    <div className='ml-8  '>
      <div className='border rounded-lg'>
      <HeaderSection
        Price={propertyData?.pricingAndOthers?.OwnershipPriceDetails?.expectedPrice || ""}
        EMI={propertyData?.emi || {}}
        Title={propertyData?.title || ""}
        propertyData={propertyData}
      />
        <div className='flex'>
          <div className='w-[40%] border bg-white'>
          <PhotoGallery images={propertyData?.mediaFiles || []}/>
          </div>
          <div className='w-[60%] px-2 bg-white'>
          <PropertyDetails
            furnishedStatus={propertyData?.aboutProperty?.furnishings?.status}
            carParking={propertyData?.aboutProperty?.parking?.coveredParking}
            bedrooms={propertyData?.aboutProperty?.roomDetails?.bedrooms}
            bathrooms={propertyData?.aboutProperty?.roomDetails?.bathrooms}
            balconies={propertyData?.aboutProperty?.roomDetails?.balconies}
            
          />
          <PropertyInfo 
            propertyData={propertyData}


          />
          </div>
        </div>
        <ContactSection/>
      </div>
        <div className='border my-3 rounded-lg'>
            <MoreDetailsSection propertyData={propertyData}/>
        </div>
       {propertyData?.aboutProject && <div className='border my-3 rounded-lg'>
          <AboutProject/>
        </div>}
        <div className='border my-3 rounded-lg'>
          <AmenitiesSection PropertyFeatures={propertyData?.pricingAndOthers?.PropertyFeatures}/>
        </div>
        <div className='border my-3 rounded-lg'>
          <OtherPropertiesSection/>
        </div>
    </div>
  )
}

export default LeftSection
